import { Success, SuccessType } from '../../data/models/Success'

const OtpParser = (data: any): SuccessType => {
  return Success.create({
    status: data?.status ?? '',
  })
}

export { OtpParser }
